import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';

import EmploymentMain from './comp/EmploymentMain'
import EmploymentDetail from './comp/EmploymentDetail'

const Employment = ({ msg, url }: any) => {

    const history = useHistory();
    const params: any = useParams();

    const viewChange = (svyrEmplyPbanNo?: string) => {

        if (svyrEmplyPbanNo) {
            history.push(url + "/" + svyrEmplyPbanNo);
        } else {
            history.push(url);
        }

    }

    return (
        <>
            {
                params['svyrEmplyPbanNo'] ?
                    <EmploymentDetail msg={msg} svyrEmplyPbanNo={params['svyrEmplyPbanNo']} viewChange={viewChange} />
                    :
                    <EmploymentMain msg={msg} viewChange={viewChange} />
            }
        </>
    );

}

export default Employment;